export const ACKODRIVE_LOGO_HORIZONTAL_LIGHT = 'https://acko-cms.ackoassets.com/Acko_Drive_Horizontal_Light_Background_7fe8813575.png'
export const ACKODRIVE_LOGO_VERTICAL_DARK = 'https://acko-cms.ackoassets.com/Acko_Drive_Vertical_Dark_Background_d325864459.png'
export const ACKODRIVE_LOGO_HORIZONTAL_DARK = 'https://acko-cms.ackoassets.com/Acko_Drive_Horizontal_Dark_Background_7552316c44.png'
